<template>
  <!-- edit profile dialog -->
  <v-dialog
    v-model="isBioDialogOpen"
    max-width="650px"
    @click:outside="$emit('update:is-bio-dialog-open',false)"
  >
    <v-card class="user-edit-info pa-sm-10 pa-3">
      <v-card-title class="justify-center text-h5">
        Editar Información de Usuario
      </v-card-title>
      <!-- <v-card-text class="text-center mt-n2">
        Updating user details will receive a privacy audit.
      </v-card-text> -->

      <v-card-text class="mt-5">
        <v-form class="multi-col-validation">
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="userDataLocal.name"
                outlined
                dense
                label="Nombre"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
            >
              <v-text-field
                v-model="userDataLocal.email"
                outlined
                dense
                label="Email"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
            >
              <v-select
                v-model="userDataLocal.country"
                :items="countries"
                outlined
                dense
                label="Country"
              ></v-select>
            </v-col>

            <template v-if="getUserRole === 0">
              <v-col cols="3" md="3" class="pr-0 pt-3">
                <v-select
                  id="selectorflags"
                  name="selectorflags"
                  v-model="items[0]"
                  :items="items"
                  label="Cod. Area"
                  :rules="[v => !!v || 'Caracteristica requerida']"
                  required
                  hide-details="auto"
                  outlined
                  dense
                  @change="changePrefix"
                ></v-select>
              </v-col>

              <v-col
                cols="9"
              >
                <v-text-field
                  v-model="userDataLocal.number"
                  outlined
                  dense
                  label="Teléfono"
                ></v-text-field>
              </v-col>
            </template>

            <v-col
              cols="12"
              class="d-flex justify-end mt-3"
            >

              <v-btn
                outlined
                class="me-3"
                color="secondary"
                @click.prevent="$emit('update:is-bio-dialog-open',false)"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
                @click.prevent="onSubmit"
              >
                Aceptar
              </v-btn>

            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    isBioDialogOpen: {
      type: Boolean,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async onSubmit() {
      try {
        const form = {
          name: this.userDataLocal.name,
          email: this.userDataLocal.email,
          country: this.userDataLocal.country,
          prefix: this.prefix,
          number: this.userDataLocal.number
        }
        /* const response =  */await this.$api.updateUserDataForProfile(form)

      } catch (e) {
        console.log(e)
      } finally {
        this.$emit('reload-data')
        this.$emit('update:is-bio-dialog-open', false)
      }
    },
    changePrefix(e) {
      const matches = e.match(/\d+/g);

      if (matches) this.prefix = Number(matches[0])
    },
  },
  computed: {
    getUserRole() { return this.$store.getters['session/getUserRole']() },
  },
  setup(props) {

    const userDataLocal = ref({})
    userDataLocal.value = JSON.parse(JSON.stringify(props.userData))


    const countries = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre & Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts & Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', `Timor L'Este`, 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe']

    watch(
      () => props.isBioDialogOpen,
      () => {
        userDataLocal.value = JSON.parse(JSON.stringify(props.userData))
      },
    )

    return {
      items: [
        "🇦🇷 (+549)",
        "🇧🇷 (+55)",
        "🇧🇴 (+591)",
        "🇨🇱 (+56)",
        "🇨🇴 (+57)",
        "🇪🇨 (+593)",
        "🇲🇽 (+52)",
        "🇵🇪 (+51) ",
        "🇵🇾 (+595)",
        "🇺🇾 (+598)",
        "🇻🇪 (+58)",
      ],
      prefix: 549,
      countries,
      userDataLocal,
    }
  },
}
</script>
